import log from 'salvo-lite/log'

class SetChoicesValue {
    constructor (theme, elem) {
        this._elem = elem
        this._linkedComponent = theme.getComponentsById(this._elem.dataset.setChoicesValue.split('|')[0])
        this._checkedValue = this._elem.dataset.setChoicesValue.split('|')[1].split(',')[1]
        this._uncheckedValue = this._elem.dataset.setChoicesValue.split('|')[1].split(',')[0]
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initializing', this)

        this._elem.addEventListener('change', e => {
            if (this._elem.checked) {
                this._linkedComponent.setValue(this._checkedValue)
            } else {
                this._linkedComponent.setValue(this._uncheckedValue)
            }
        })

        log.debug(this.constructor.name, 'Initialized', this)
    }
}

export default SetChoicesValue



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SetChoicesValue.js